import script from "./InviteView.vue?vue&type=script&setup=true&lang=js"
export * from "./InviteView.vue?vue&type=script&setup=true&lang=js"

import "./InviteView.vue?vue&type=style&index=0&id=7b57ba66&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b57ba66"]])

export default __exports__